import { render, staticRenderFns } from "./SrTableHeading.vue?vue&type=template&id=a40cecc6"
import script from "./SrTableHeading.vue?vue&type=script&lang=js"
export * from "./SrTableHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports